export default function ClockArrow({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <path
        d="M13.4191 3.11328C17.7151 3.79399 21.0002 7.51255 21.0002 12C21.0002 16.9703 16.9704 20.9996 12.0002 21C7.18488 21 3.25284 17.2183 3.0119 12.4629L3.00018 12H1.70624C1.39555 11.9998 1.2038 11.661 1.36347 11.3945L3.65741 7.57129C3.81296 7.31311 4.18762 7.31286 4.34296 7.57129L6.6369 11.3945C6.79612 11.6609 6.60356 11.9997 6.29315 12H5.00018C5.00018 15.866 8.13419 19 12.0002 19C15.8659 18.9996 19.0002 15.8658 19.0002 12C19.0002 8.47382 16.3921 5.55785 13.0002 5.07227V3.05664L13.4191 3.11328Z"
        fill="currentColor"
      />
      <path
        d="M11.0002 3C11.5523 3.00016 12.0002 3.44782 12.0002 4V10.4648L15.5549 13.168L15.6369 13.2285C16.0281 13.5508 16.1193 14.1238 15.8322 14.5547C15.5451 14.9854 14.9813 15.1216 14.5334 14.8848L14.4455 14.832L10.0002 11.5352V4C10.0002 3.44772 10.4479 3 11.0002 3Z"
        fill="currentColor"
      />
    </svg>
  )
}
